export default __webpack_public_path__ + "static/media/multi-location.e5e538e8.svg";